import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../helper/axiosConfig";
import axios from "axios";
import MobileBottomBar from "../Layout/MobileBottomBar";


function PrivacyPolicy() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  
  useEffect(() => {
    // Scroll to top is now handled globally in Layout component
    fetchPolicy();
  }, [navigate]);


  const fetchPolicy = async () => {
    // let div = document.getElementById("diviineerr");
    try {
      const res = await axios.get(`${baseUrl}/privacy-policy`);
    //   console.log(res.data.data.description);

      setTitle(res.data.data.title);
      setDescription(res.data.data.description);
    //   div.innerHTML = res.data.data.description;
    } catch (error) {
    }
  };

  return (
    <>
      <section className="modern-page-banner">
        <div className="container">
          <div className="banner-content">
            <div className="banner-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h1 className="banner-title">Privacy Policy</h1>
            <p className="banner-subtitle">Your privacy matters to us</p>
          </div>
        </div>
      </section>

      <section className="modern-content-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="intro-section">
              <div className="intro-card">
                <p className="intro-text">
                  At Fynito, your privacy is our top priority. This Privacy Policy explains
                  how we collect, use, and safeguard your personal information.
                </p>
              </div>
            </div>

            <div className="policy-section">
              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-info-circle"></i>
                  </div>
                  <h5 className="section-title">Information We Collect:</h5>
                </div>
                <ul className="modern-content-list">
                  <li>
                    Personal details like name, email, and phone number when you register.
                  </li>
                  <li>Location data to deliver your orders.</li>
                  <li>Payment information for processing transactions securely.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-cogs"></i>
                  </div>
                  <h5 className="section-title">How We Use Your Information:</h5>
                </div>
                <ul className="modern-content-list">
                  <li>To fulfill and deliver your orders.</li>
                  <li>To improve our app and services.</li>
                  <li>To provide customer support and communication.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-share-alt"></i>
                  </div>
                  <h5 className="section-title">Sharing Your Information:</h5>
                </div>
                <ul className="modern-content-list">
                  <li>We do not sell your data to third parties.</li>
                  <li>
                    We may share your information with delivery partners and restaurants to
                    process your orders.
                  </li>
                </ul>
              </div>

              <div className="policy-card highlight-card">
                <div className="section-header">
                  <div className="section-icon warning">
                    <i className="fas fa-exclamation-triangle"></i>
                  </div>
                  <h5 className="section-title">DATA DELETION REQUEST</h5>
                </div>
                <p className="deletion-intro">
                  If you would like to request the deletion of your personal data from
                  fynito, please follow the steps outlined below:
                </p>
                
                <div className="deletion-steps">
                  <div className="step-item">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h6>Contact Us</h6>
                      <p>
                        To request the deletion of your personal data, send an email to
                        our team at <Link to="mailto:support@fynito.com" className="email-link">support@fynito.com</Link> or reach out through
                        our contact form. Be sure to provide your email address or other relevant
                        account information to help us locate and accurately identify your data.
                      </p>
                    </div>
                  </div>

                  <div className="step-item">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h6>Identity Verification</h6>
                      <p>
                        To ensure the security of your data, we may need to
                        verify your identity before proceeding with your request. You may be asked
                        to provide additional information or documentation to confirm your
                        identity.
                      </p>
                    </div>
                  </div>

                  <div className="step-item">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h6>Data Deletion Process</h6>
                      <p>
                        Once your identity is verified, we will delete your
                        personal data from our systems, including any identifiable information
                        related to your account, orders, and website interactions. Please note
                        that some data may be retained for legal or administrative purposes, as
                        required by law.
                      </p>
                    </div>
                  </div>

                  <div className="step-item">
                    <div className="step-number">4</div>
                    <div className="step-content">
                      <h6>Confirmation</h6>
                      <p>
                        Upon successfully deleting your data, we will send you a
                        confirmation email or notification to confirm that the process is
                        complete.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="important-notes">
                  <h6>Important Notes:</h6>
                  <ul className="modern-content-list">
                    <li>
                      Deleting your personal data may result in the loss of
                      access to certain features or services that rely on your data for
                      functionality.
                    </li>
                    <li>
                      Some information may need to be retained to comply with legal obligations
                      or resolve disputes. For further questions or concerns, feel free to
                      contact our privacy team for assistance.
                    </li>
                  </ul>
                  <div className="contact-info">
                    <Link to="mailto:support@fynito.com" className="contact-email">
                      <i className="fas fa-envelope"></i>
                      support@fynito.com
                    </Link>
                  </div>
                </div>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-lock"></i>
                  </div>
                  <h5 className="section-title">Data Security:</h5>
                </div>
                <p>
                  We implement industry-standard security measures to protect your data.
                </p>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <h5 className="section-title">Agreement:</h5>
                </div>
                <p>
                  By using Fynito, you agree to this Privacy Policy. For any concerns,
                  contact us at <Link to="mailto:support@fynito.com" className="email-link">support@fynito.com</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container">
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div> */}
      </section>

      {/* Mobile Bottom Bar */}
      <MobileBottomBar />
    </>
  );
}

export default PrivacyPolicy;
